<template>
  <div>

    <b-row>
      <b-col cols="6" class="px-0">
        <label v-bind:style="isReadonly ? '' : selectorStyles">
          <div class="circle rounded-circle">
            <img v-if="!avatar"
                 class="default-avatar"
                 :height="avatarHeight"
                 :width="avatarWidth"
                 :alt="$t('message.avatar.default')"
                 src="~/ti-icons/SVG/user.svg">
            <img v-if="avatar"
                 class="rounded-circle"
                 :height="avatarHeight"
                 :width="avatarWidth"
                 :alt="$t('message.avatar.default')"
                 :src="avatarSrc">
          </div>
          <input type="file" hidden @change="onFileChanged" accept="image/*" :disabled="isReadonly">
        </label>
        <label v-if="!isReadonly"
               class="text-center mt-3"
               v-bind:style="isReadonly ? '' : selectorStyles">
          {{ $t('message.avatar.maxFileDimensions') }}
          <br>
          {{ $t('message.avatar.maxFileDimensionsValue' , {
          height: maxHeight,
          width: maxWidth
          }) }}
          <input type="file" hidden @change="onFileChanged" accept="image/*" :disabled="isReadonly">
        </label>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  export default {
    props: {
      avatar: {
        required: true
      },
      isReadonly: {
        type: Boolean,
        required: true
      },
      maxFileSize: {
        type: Number,
        default: 6 * 1024 * 1024
      },
      maxHeight: {
        type: Number,
        default: 600
      },
      maxWidth: {
        type: Number,
        default: 600
      },
      size: {
        type: String
      }
    },
    computed: {
      avatarSrc () {
        return (this.avatar && this.avatar.uuid) ? process.env.BACKEND_URL + 'avatars/' + this.avatar.uuid : this.avatar
      },
      avatarWidth () {
        if (this.size && this.size === 'sm') {
          return 100
        }
        return 150
      },
      avatarHeight () {
        if (this.size && this.size === 'sm') {
          return 100
        }
        return 150
      }
    },
    data () {
      return {
        selectorStyles: {
          'cursor': 'pointer'
        }
      }
    },
    methods: {
      onFileChanged (event) {
        const selectedFile = event.target.files[0]
        event.target.value = null
        if (selectedFile) {
          const reader = new FileReader()
          reader.readAsDataURL(selectedFile)
          reader.onload = (readerEvent) => {
            const image = new Image()
            const newAvatar = readerEvent.target.result
            image.src = newAvatar
            image.onerror = () => {
              this.showErrorMsg({
                message: this.$t('error.avatar.wrongFileType')
              })
            }
            image.onload = () => {
              if (this.validteImage(selectedFile, image)) {
                this.$emit('onUpdateAvatar', selectedFile, newAvatar)
                this.avatarName = selectedFile.name
              }
            }
          }
        }
      },
      validteImage (file, image) {
        if (file.size > this.maxFileSize) {
          this.showErrorMsg({
            message: this.$t('error.avatar.fileToolarge')
          })
          return false
        }
        if (image.height > this.maxHeight || image.width > this.maxHeight) {
          this.showErrorMsg({
            message: this.$t('error.avatar.wrongDimensions')
          })
          return false
        }
        return true
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      }
    }
  }

</script>

<style scoped>
  .circle {
    border: 1px solid lightgrey;
  }

  .default-avatar {
    padding-left: 15%;
    padding-right: 15%;
    padding-bottom: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/AvatarForm.vue